module.exports = __webpack_public_path__ + "media/dogs/order-failed-dog-0bf7b4d9.svg";